module.exports = __webpack_public_path__ + "static/media/cedula-50.2e5bc462.png";